import React from "react";
import { LegalLayout, H2, P, UL, LI } from "@/components/LegalLayout";

export default function Eula() {
  return (
    <LegalLayout
      title="End User License Agreement"
      updated="June 1, 2026"
      intro="This EULA is a legal agreement between you and Next Time governing your use of the Next Time app and website (the “Software”)."
    >
      <H2>1. License grant</H2>
      <P>Subject to your compliance with this Agreement, we grant you a personal, limited, non-exclusive, non-transferable, revocable license to download, install, and use the Software for your own personal, non-commercial use on devices you own or control.</P>

      <H2>2. Ownership</H2>
      <P>The Software is licensed, not sold. We and our licensors retain all right, title, and interest in and to the Software, including all intellectual property rights. No rights are granted to you other than as expressly set out in this Agreement.</P>

      <H2>3. Restrictions</H2>
      <P>You agree that you will not, and will not permit others to:</P>
      <UL>
        <LI>copy, modify, or create derivative works of the Software;</LI>
        <LI>reverse engineer, decompile, or disassemble the Software, except to the extent this restriction is prohibited by law;</LI>
        <LI>rent, lease, lend, sell, sublicense, or otherwise commercially exploit the Software;</LI>
        <LI>remove or alter any proprietary notices;</LI>
        <LI>use the Software to build a competing product, or to train machine-learning models;</LI>
        <LI>use the Software in any unlawful manner or in violation of these terms.</LI>
      </UL>

      <H2>4. User content</H2>
      <P>You retain ownership of the content you create. You grant us a limited license to process that content solely to operate and provide the Software (including AI analysis and feedback), as described in our <a href="/privacy" className="underline hover:text-ink">Privacy Policy</a>.</P>

      <H2>5. AI-generated output</H2>
      <P>The Software uses AI to generate scenarios, responses, and feedback. Output may be inaccurate, incomplete, or unsuitable for your situation. You are responsible for how you use it. See our <a href="/disclaimer" className="underline hover:text-ink">Disclaimer &amp; Safety</a> notice.</P>

      <H2>6. Purchases</H2>
      <P>Paid features include an auto-renewing Pro subscription and one-time consumable point packs (virtual items used inside the app). Both are governed by our <a href="/subscription-terms" className="underline hover:text-ink">Subscription &amp; Purchase Terms</a> and by the store you purchased through.</P>

      <H2>7. App store terms</H2>
      <P>If you obtained the Software from the Apple App Store, you acknowledge that this Agreement is between you and Next Time only, not Apple, and that Apple is not responsible for the Software or its support. Apple and its subsidiaries are third-party beneficiaries of this Agreement and may enforce it. Similar terms apply to Google Play and other distribution platforms.</P>

      <H2>8. Termination</H2>
      <P>This license is effective until terminated. It terminates automatically if you breach any term. Upon termination, you must stop using the Software and delete all copies. Sections that by their nature should survive will survive termination.</P>

      <H2>9. Disclaimer and limitation of liability</H2>
      <P>The Software is provided “as is” without warranties of any kind. To the maximum extent permitted by law, Next Time is not liable for any indirect, incidental, or consequential damages arising from your use of the Software. This Agreement is subject to the disclaimers in our <a href="/terms" className="underline hover:text-ink">Terms of Service</a>.</P>

      <H2>10. Contact</H2>
      <P>Questions about this Agreement? Email <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a>.</P>
    </LegalLayout>
  );
}
